import { call, put, takeLatest, all } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchUpcomingEventsRequest,
  fetchUpcomingEventsSuccess,
  fetchUpcomingEventsFailure,
} from '../slices/upcomingEventsSlice';
import type {
  GlobalHolidaysResponse,
  LocalEventsResponse,
  EventMasterResponse,
} from '../../components/upcomingEvents/types';

function* fetchUpcomingEventsSaga(
  action: PayloadAction<{ restaurantId: string; countryCode: string }>
): Generator<any, void, any> {
  try {
    const { restaurantId, countryCode } = action.payload;

    // Fetch all 3 APIs in parallel
    const [holidaysResponse, localEventsResponse, eventMasterResponse] = yield all([
      // Global Holidays with country code
      call(
        axios.get,
        `${BASE_API_URL}${ENDPOINTS.holidaysWithRestaurant}/${restaurantId}?country_code=${countryCode}`
      ),
      // Local Events with country code
      call(
        axios.get,
        `${BASE_API_URL}${ENDPOINTS.localEvents}/${restaurantId}?country_code=${countryCode}`
      ),
      // Event Master (no restaurant ID needed)
      call(axios.get, ENDPOINTS.eventMaster),
    ]);

    // Parse responses
    const holidaysData: GlobalHolidaysResponse = holidaysResponse.data;
    const localEventsData: LocalEventsResponse = localEventsResponse.data;
    const eventMasterData: EventMasterResponse = eventMasterResponse.data;

    // Dispatch success with all data
    yield put(
      fetchUpcomingEventsSuccess({
        holidays: holidaysData.data || [],
        localEvents: localEventsData.data || [],
        eventMaster: eventMasterData.data || [],
      })
    );
  } catch (error: any) {
    yield put(
      fetchUpcomingEventsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch upcoming events'
      )
    );
  }
}

export function* upcomingEventsSaga() {
  yield takeLatest(fetchUpcomingEventsRequest.type, fetchUpcomingEventsSaga);
}
